<template>
  <div class="detailed_report_form" :style="screenHeight">
    <div class="fixed_search" style="height: 100px;">
      <div class="fixed_search_input">
        <Select v-model="formType" placeholder="请选择报表类型" title="报表类型">
          <Option v-for="(option, index) in formTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="reportType" placeholder="请选择统计类型" title="统计类型">
          <Option v-for="(option, index) in reportTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker title="日期" v-model="starEndTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="false" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div v-show="'1' == reportType" class="fixed_search_input">
        <div class="selectDiv">
          <Select v-model="name" multiple :max-tag-count="1" clearable title="SLA名称">
            <Option v-for="(option, index) in slaList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
      </div>
      <div v-show="'2' == reportType" class="fixed_search_input">
        <div class="selectDiv">
          <Select v-model="name" multiple :max-tag-count="1" clearable title="工单分类">
            <Option v-for="(option, index) in orderList" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>
        </div>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareNum"  clearable title="工单数量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="num" placeholder="工单数量" title="工单数量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareResponseIn"  clearable title="响应达标数量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="responseIn" placeholder="响应达标数量" title="响应达标数量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareResponseOut"  clearable title="响应超时数量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="responseOut" placeholder="响应超时数量" title="响应超时数量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareProcessIn"  clearable title="处理达标数量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="processIn" placeholder="处理达标数量" title="处理达标数量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareProcessOut"  clearable title="处理超时数量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="processOut" placeholder="处理超时数量" title="处理超时数量"/>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" @click="exportExcel('8_7-5-1','统计报表=>工单统计=>SLA服务等级统计')" v-if="roleList['8_7-5-1']">导出</Button>
      </div>
      <div class="fixed_operation_btn" style="margin-top:-3px">
        <Tooltip class="tips_font" placement="bottom">
          <div slot="content">
            <p>该统计页面应用工单数据权限（详细说明参考工单概览）</p>
            <p>日期：统计的单位时间</p>
            <p>SLA/工单类型：单位时间内的（SLA/工单类型）名称</p>
            <p>工单数量：单位时间内该（SLA/工单类型）的工单量</p>
            <p>响应达标数量：单位时间内该（SLA/工单类型）响应时长达标的工单量</p>
            <p>响应超时数量：单位时间内该（SLA/工单类型）响应时长超时的工单量</p>
            <p>响应达标率：单位时间内该（SLA/工单类型）响应时长达标的工单量÷单位时间内该（SLA/工单类型）的工单量</p>
            <p>处理达标数量：单位时间内该（SLA/工单类型）处理时长达标的工单量</p>
            <p>处理超时数量：单位时间内该（SLA/工单类型）处理时长超时的工单量</p>
            <p>处理达标率：单位时间内该（SLA/工单类型）处理时长达标的工单量÷单位时间内该（SLA/工单类型）的工单量</p>
          </div>
          <img src="../../../assets/image/homeAsk.png"/>
        </Tooltip>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width">
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top">
              <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</span>
              <div slot="content" >
                <span>{{item.title}}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    export default {
        name: "SlaServiceLevelStatistics",
      mixins:[publicFunClass,customerPublicBtn],
      props:{
        pageCode:String
      },
      data(){
        return {
          roleList:JSON.parse(localStorage.getItem("roleList")),
          screenHeight:{height:''},
          tableHeight:600,
          total:0,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          pageSize:20,
          speedChangePage: 1,
          spinShow:false,
          popSign:'',
          fieldList: [
            {fixed: true,key:'date','title':'日期'},{key:'name','title':'SLA'},{key:'num','title':'工单数量'},
            {key:'responseIn','title':'响应达标数量'},{key:'responseOut','title':'响应超时数量'},{key:'responseInAverage','title':'响应达标率(%)'},
            {key:'processIn','title':'处理达标数量'},{key:'processOut','title':'处理超时数量'},{key:'processInAverage','title':'处理达标率(%)'},
          ],
          contentList: [],
          compareList:[{'id':'>','name':'大于'},{'id':'=','name':'等于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'<=','name':'小于等于'}],
          starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
          journalType:"null",
          menuId:"null",
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          formTypeList:[{'id':'1','name':'日报'},{'id':'2','name':'周报'},{'id':'3','name':'月报'}],
          formType:'1',
          tableClass: true,
          reportTypeList:[{'id':'2','name':'工单类型'},{'id':'1','name':'SLA'}],
          reportType:'1',
          showPageCount:0,
          isOpenOrderType:localStorage.getItem('isOpenOrderType'),
          name:'',
          num:"",
          responseIn:"",
          responseOut:"",
          processIn:"",
          processOut:"",
          compareNum:"",
          compareResponseIn:"",
          compareResponseOut:"",
          compareProcessIn:"",
          compareProcessOut:"",
          slaList:[],
          orderList:[],
          oldParam:{},
        }
      },
      methods:{
        initSearch:function () {
          this.spinShow=true;
          this.$emit("closeVn",true);
          let param={
            formType:this.formType,
            name:this.name ? this.name.toString() : '',
            num:this.num,
            statisticsType:this.reportType,
            responseIn:this.responseIn,
            responseOut:this.responseOut,
            date:this.starEndTime.length==0?"":this.starEndTime.toString(),
            processIn:this.processIn,
            processOut:this.processOut,
            compareNum:this.compareNum,
            compareResponseIn:this.compareResponseIn,
            compareResponseOut:this.compareResponseOut,
            compareProcessIn:this.compareProcessIn,
            compareProcessOut:this.compareProcessOut,
            journalType:"null",
            menuId:"null",
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            currentPage:this.currentPage,
          };
          if('2' == this.reportType){
            this.fieldList[1].title = '工单类型';
          }else{
            this.fieldList[1].title = 'SLA';
          }
          let that=this;
          this.oldParam = param;
          this.$http.post("orderForm/toSlaServiceLevelStatisticsIndex.json",param) .then(function (res) {
            let result=res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.contentList=res.data.obj.list.content;
            that.total=res.data.obj.list.totalSize;
            that.slaList=res.data.obj.slaList;
            that.orderList=res.data.obj.orderList;
          })
        },
        reset:function(){
          this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
          this.name = "";
          this.formType = "1";
          this.num = "";
          this.responseIn = "";
          this.responseOut = "";
          this.processIn = "";
          this.processOut = "";
          this.compareNum = "";
          this.compareResponseIn = "";
          this.compareResponseOut = "";
          this.compareProcessIn = "";
          this.compareProcessOut = "";
          this.reportType = '1';
        },
        //导出
        exportExcel:function (menuId,journalType) {
          if(this.contentList.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可导出的数据"
            });
            return false;
          }
          if(!this.oldParam){
            this.$Modal.info({
              title:'提示',
              content:"请点击查询后再导出"
            });
            return false;
          }
          this.journalType=journalType;
          this.menuId=menuId;
          //统计报表没有按选中结果导出
          let param = JSON.parse(JSON.stringify(this.oldParam));
          param.type = '1';
          param.journalType = this.journalType+"按搜索结果导出";
          param.menuId = this.menuId;
          this.$delete(param,'pageNum');
          this.$delete(param,'pageSize');
          this.$delete(param,'currentPage');
          this.$Loading.start();
          this.operateExcelExport(param,"orderForm/exportSlaServiceLevelStatistics.json");
        },
      },
      created(){
        this.oldParam = {};
        this.screenHeight.height=this.mountHeight(91);
        let clientHeight=document.documentElement.clientHeight;
        this.tableHeight=clientHeight-232;
        if('0' == this.isOpenOrderType){
          this.reportTypeList = [{'id':'1','name':'SLA'}];
          this.reportType = '1';
        }
      },
      destroyed(){
        this.$emit("closeVn",true);
        clearInterval(this.scrollInterval);
      },
      watch:{
        pageCode:function () {
          if(this.pageCode=='8_7-5' && this.showPageCount==0){
            this.$emit("openVn", true);
            this.showPageCount++;
            this.handleScroll();
          }
        }
      }
    }
</script>

<style scoped>
  .detailed_report_form /deep/ ivu-tag ivu-tag-checked{
    height: 18px!important;
    line-height: 18px!important;
  }
  .detailed_report_form /deep/ ivu-icon ivu-icon-ios-close{
    top: 1px!important;
  }
  .detailed_report_form /deep/ .ivu-select-multiple .ivu-select-input {
    height: 18px !important;
    line-height: 18px !important;
  }
  .detailed_report_form /deep/ .ivu-select-multiple .ivu-tag{
    height: 18px!important;
    line-height: 18px!important;
  }
  .detailed_report_form /deep/ .fixed_search .fixed_search_input .ivu-icon{
    line-height: 18px!important;
  }
  .selectDiv /deep/ .ivu-select-multiple .ivu-tag .ivu-icon{
    line-height: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/workOrderReportForm/SlaServiceLevelStatistics.vue